import React from 'react';
import './header.scss';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import appConfig from '../../app-config';

export default class Header extends React.Component {
  render() {
    return (
      <header className='header-component'>
        <Navbar expand='lg' className={'bg-body-tertiary fp-nav ' + (window.location.pathname === '/' ? 'fp-header-left-offset' : '')}>
          <Container>
            <Navbar.Brand className='justify-content-start fp-navbar-brand' href='/'>
              <img
                alt='fp-digital-photo-white'
                src='/assets/fp-digital-photo-logo.png'
                width='30'
                height='30'
                className='d-inline-block align-top'
              />{' '}
              {appConfig.app.title}
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='basic-navbar-nav' />
            <Navbar.Collapse id='basic-navbar-nav'>
              <Nav
                activeKey={window.location.pathname}
                className='me-auto'
              >
                {this.props.navigationItems.map(item => (
                  <Nav.Item>
                    <Nav.Link className='fp-nav-link' eventKey={item.path} href={item.path}>{item.text}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}